import styles from './list.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleX } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';

export default function NoData() {
	return (
		<div className={styles['no-data']}>
			<FontAwesomeIcon icon={faCircleX} size='lg' /> No Trials Found
		</div>
	);
}
